const module = { name: 'shared/seatMap/constants', exports: {} }; const exports = module.exports;



import { Fandango_cookie as Fandango_cookie_deleteCookie_get_getCookie } from 'require-core';

const { deleteCookie, get: getCookie } = Fandango_cookie_deleteCookie_get_getCookie;


import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


const SeatTypes = {
    COMPANION: 'companion',
    STANDARD: 'standard',
    TWO_SEATER: 'twoseater',
    LINKED: 'linked',
    WHEELCHAIR: 'wheelchair',
}


const MapTypes = {
    INTERACTIVE: 'interactive',
    PREVIEW: 'preview',
}


const StatusCodes = {
    AVAILABLE: ['A', 'H'],
    UNAVAILABLE: ['O', 'R', 'X'],
}
function clearSeatSelectionOnOrderComplete() {
    const completedShowtimeHashes = getCookie(CookieNames.SEAT_SELECTION_COMPLETED);
    if (completedShowtimeHashes) {
        completedShowtimeHashes.split(',').forEach(hash => sessionStorage.removeItem(`seatSelection-${hash}`));
        deleteCookie(CookieNames.SEAT_SELECTION_COMPLETED, { domain: '.fandango.co.uk', path: '/' });
    }
}
module.exports = { SeatTypes, MapTypes, StatusCodes, clearSeatSelectionOnOrderComplete };
export default module.exports;